import { useQuery, useMutation, useQueryClient } from 'react-query';
import { getSystemNotificationLogs, markNotificationLogRead } from 'util/rehive';

const STALE_TIME = 60000 * 5; // 5 minutes

export function useSystemNotifications(enabled = true) {
  const queryResult = useQuery(
    'system-notifications',
    () => getSystemNotificationLogs('?page_size=50'),
    {
      enabled,
      staleTime: STALE_TIME,
    }
  );

  return queryResult;
}

export function useMarkNotificationRead() {
  const queryClient = useQueryClient();
  
  return useMutation(
    (id) => markNotificationLogRead(id),
    {
      onSuccess: () => {
        queryClient.invalidateQueries('system-notifications');
      },
    }
  );
}
